import { NavLink } from "react-router-dom";
import LogoFooter from "../img/logo-htcr.png";
import LogoFooterWhite from "../img/logo-htcr-white.png";
import IconYoutube from "../img/icons/icon-youtube.svg";
import IconFacebook from "../img/icons/icon-facebook.svg";
import IconTwitter from "../img/icons/icon-twitter.svg";
import IconInstagram from "../img/icons/icon-instagram.svg";
import IconLinkedin from "../img/icons/icon-linkedin.svg";
import IconClock from "../img/icons/icon-clock.svg";
import IconEmail from "../img/icons/icon-email.svg";
import {Config} from "../Config";
import React from "react";

export default function Footer(prop) {

    let [data, setData] = React.useState(null);

    let [newsCategory, setNewsCategory] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getContact();

                if(prop !== null && prop.lang === 'en') {
                    resView.title = resView.title_en;
                    resView.address = resView.address_en;
                }

                setData(resView);

                const newCategoryList = await getNewsCategory();
                setNewsCategory(newCategoryList);
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getContact() {
        const response = await fetch(Config.apiUrl +'contact/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getNewsCategory() {
        const response = await fetch(Config.apiUrl +'newsCategory/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <footer className="footer" data-aos="fade-in">
                <div className="container">
                    <div className="footer-logo">
                        <img className="logo page-dark-disable" src={LogoFooter} alt="HTCR Logo" />
                        <img className="logo page-dark-visible" src={LogoFooterWhite} alt="HTCR Logo" />
                        <div>
                            <h5>ศูนย์รวมผู้เชี่ยวชาญการวิจัยเพื่อความมั่นคงปลอดภัยไซเบอร์แห่งประเทศไทย</h5>
                            <p>Thailand Hub of Talents in Cybersecurity Research</p>
                        </div>
                    </div>

                    <div className="footer-info">
                        {
                            data?.address ? <p>{data?.address}</p> : ''
                        }

                        <div className="d-none d-lg-block">
                            {
                                data?.phone ? <p><a className="tel" href={"tel:" + data?.phone.replaceAll(' ', '')}>+ {data?.phone}</a></p> : ''
                            }

                            <p className="icon-text mb-2">
                                <img className="icons svg-js" src={IconClock} alt="" />
                                <span className="fs-16">{prop.lang === 'en' ? 'Mon.-Fri. 8:30 AM - 4:30 PM.':'จ.-ศ. เวลา 08:30 น. - 16:30 น.'}</span>
                            </p>

                            {
                                data?.email ? <p className="icon-text mb-2">
                                    <img className="icons svg-js" src={IconEmail} alt="HTCR Email" />
                                    <a className="link" href={"mailto:" + data?.email}>{data?.email}</a>
                                </p> : ''
                            }

                            <div className="followus">
                                {
                                    data?.youtube ? <a href={data?.youtube} target="_blank">
                                        <img className="icons svg-js" src={IconYoutube} alt="HTCR Youtube" />
                                    </a> : ''
                                }

                                {
                                    data?.facebook ? <a href={data?.facebook} target="_blank">
                                        <img className="icons svg-js" src={IconFacebook} alt="HTCR Facebook" />
                                    </a> : ''
                                }

                                {
                                    data?.twitter ? <a href={data?.twitter} target="_blank">
                                        <img className="icons svg-js w-16" src={IconTwitter} alt="HTCR X" />
                                    </a> : ''
                                }

                                {
                                    data?.instagram ? <a href={data?.instagram} target="_blank">
                                        <img className="icons svg-js" src={IconInstagram} alt="HTCR Instagram" />
                                    </a> : ''
                                }

                                {
                                    data?.linkedin ? <a href={data?.linkedin} target="_blank">
                                        <img className="icons svg-js" src={IconLinkedin} alt="HTCR Linkedin" />
                                    </a> : ''
                                }
                            </div>
                        </div>
                    </div>

                    <div className="footer-links">
                        <div className="cols">
                            <ul className="nav nav-footer">
                                <li><a href={prop.lang === 'en' ? '/en/home':'/home'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a></li>
                                <li>
                                    <a href="#">{prop.lang === 'en' ? 'About HTCR':'เกี่ยวกับ ศชวซ.'}</a>
                                    <ul>
                                        <li><a href={prop.lang === 'en' ? '/en/about':'/about'}>{prop.lang === 'en' ? 'About Us':'ประวัติความเป็นมา'}</a></li>
                                        <li><a href={prop.lang === 'en' ? '/en/mission':'/mission'}>{prop.lang === 'en' ? 'Mission':'วิสัยทัศน์/พันธกิจ'}</a></li>
                                        <li><a href={prop.lang === 'en' ? '/en/organization':'/organization'}>{prop.lang === 'en' ? 'Organization':'โครงสร้างคณะทำงาน ศชวซ.'}</a></li>
                                        <li><a href={prop.lang === 'en' ? '/en/authority':'/authority'}>{prop.lang === 'en' ? 'Authority':'อำนาจหน้าที่'}</a></li>
                                        <li><a href={prop.lang === 'en' ? '/en/plan':'/plan'}>{prop.lang === 'en' ? 'Plan':'แผนการดำเนินงาน'}</a></li>
                                    </ul>
                                </li>

                                <li>
                                    <a href="#">{prop.lang === 'en' ? 'News':'ข่าวสาร'}</a>
                                    <ul>
                                        {
                                            newsCategory !== null && newsCategory.count > 0 ?
                                                <>
                                                    {
                                                        newsCategory.rows.map((row, index) => {
                                                            return (
                                                                <li key={index}><a href={prop.lang === 'en' ? '/en/news/category/' + row.slug:'/news/category/' + row.slug}>{prop.lang === 'en' ? row.title_en:row.title}</a></li>
                                                            )
                                                        })
                                                    }
                                                </> : ''
                                        }
                                        <li><a href={prop.lang === 'en' ? '/en/announcement':'/announcement'}>{prop.lang === 'en' ? 'Announcement':'ประกาศ ศชวซ.'}</a></li>
                                        <li><a href={prop.lang === 'en' ? '/en/infographic':'/infographic'}>{prop.lang === 'en' ? 'Infographic':'Infographic'}</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                        <div className="cols">
                            <ul className="nav nav-footer ms-3">
                                <li>
                                    <a href="#">{prop.lang === 'en' ? 'Experts List':'รายชื่อผู้เชี่ยวชาญ'}</a>
                                    <ul>
                                        <li><a href={prop.lang === 'en' ? '/en/experts':'/experts'}>{prop.lang === 'en' ? 'Experts List':'รายชื่อผู้เชี่ยวชาญ'}</a></li>
                                        <li><a href={prop.lang === 'en' ? '/en/experts_report':'/experts_report'}>{prop.lang === 'en' ? 'Experts Report':'สถิติที่เกี่ยวข้อง'}</a></li>
                                    </ul>
                                </li>
                                <li>
                                    <a href="#">{prop.lang === 'en' ? 'Publication documents':'เอกสารเผยแพร่'}</a>
                                    <ul>
                                        <li><a href={prop.lang === 'en' ? '/en/operating_result':'/operating_result'}>{prop.lang === 'en' ? 'Operating Results':'ผลการดำเนินงานของ ศชวซ.'}</a></li>
                                        <li><a href={prop.lang === 'en' ? '/en/member_result':'/member_result'}>{prop.lang === 'en' ? 'Member Results':'ผลการดำเนินงานของสมาชิก'}</a></li>
                                    </ul>
                                </li>
                                <li><a href={prop.lang === 'en' ? '/en/partners':'/partners'}>{prop.lang === 'en' ? 'Partners':'หน่วยงานเครือข่าย'}</a></li>
                                <li><a href={prop.lang === 'en' ? '/en/contact':'/contact'}>{prop.lang === 'en' ? 'Contact Us':'ติดต่อเรา'}</a></li>
                                <li><a href={prop.lang === 'en' ? '/en/sitemap':'/sitemap'}>{prop.lang === 'en' ? 'Site Map':'แผนผังเว็บไซต์'}</a></li>
                            </ul>
                        </div>

                        <div className="cols d-block d-lg-none">
                            {
                                data?.phone ? <p className="m-0"><a className="tel" href={"tel:" + data?.phone.replaceAll(' ', '')}>+ {data?.phone}</a></p> : ''
                            }

                            <p className="icon-text mb-2">
                                <img className="icons svg-js" src={IconClock} alt="" />
                                <span className="fs-16">{prop.lang === 'en' ? 'Mon.-Fri. 8:00 AM - 4:00 PM.':'จ.-ศ. เวลา 08:00 น. - 16:00 น.'}</span>
                            </p>

                            {
                                data?.email ? <p className="icon-text mb-2">
                                    <img className="icons svg-js" src={IconEmail} alt="HTCR Email" />
                                    <a className="link" href={"mailto:" + data?.email}>{data?.email}</a>
                                </p> : ''
                            }

                            <div className="followus">
                                {
                                    data?.youtube ? <a href={data?.youtube} target="_blank">
                                        <img className="icons svg-js" src={IconYoutube} alt="HTCR Youtube" />
                                    </a> : ''
                                }

                                {
                                    data?.facebook ? <a href={data?.facebook} target="_blank">
                                        <img className="icons svg-js" src={IconFacebook} alt="HTCR Facebook" />
                                    </a> : ''
                                }

                                {
                                    data?.twitter ? <a href={data?.twitter} target="_blank">
                                        <img className="icons svg-js w-16" src={IconTwitter} alt="HTCR X" />
                                    </a> : ''
                                }

                                {
                                    data?.instagram ? <a href={data?.instagram} target="_blank">
                                        <img className="icons svg-js" src={IconInstagram} alt="HTCR Instagram" />
                                    </a> : ''
                                }

                                {
                                    data?.linkedin ? <a href={data?.linkedin} target="_blank">
                                        <img className="icons svg-js" src={IconLinkedin} alt="HTCR Linkedin" />
                                    </a> : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="footer-copyright" data-aos="fade-in" data-aos-offset="0">
                <div className="container">
                    <p>{prop.lang === 'en' ? 'Copyright © 2025, All Right Reserved. HTCR':'Copyright © 2025, All Right Reserved. ศชวซ.'} <span className="d-none d-sm-inline">|</span> <br
                        className="d-block d-sm-none" />{prop.lang === 'en' ? 'Thailand Hub of Talents in Cybersecurity Research':'ศูนย์รวมผู้เชี่ยวชาญการวิจัยเพื่อความมั่นคงปลอดภัยไซเบอร์แห่งประเทศไทย'}</p>
                </div>
            </div>
        </>
    );
} 